import type { ZoneInfo, Zone } from '../types/zone';

export function sortZones(zones: ZoneInfo[]): ZoneInfo[] {
  return [...zones].sort((a, b) => {
    const [, aNumber, aLetter] = a.zone_number.match(/^(\d+)([A-B])$/) || [];
    const [, bNumber, bLetter] = b.zone_number.match(/^(\d+)([A-B])$/) || [];
    
    const numberComparison = parseInt(aNumber) - parseInt(bNumber);
    if (numberComparison !== 0) return numberComparison;
    
    return aLetter.localeCompare(bLetter);
  });
}

export function parseZone(zone: string | null): Zone | null {
  if (!zone) return null;
  const match = zone.match(/^(\d+)[A-B]$/);
  return match ? zone as Zone : null;
}

export function zoneToNumber(zone: string): number {
  if (!zone) return 0;
  const match = zone.match(/^(\d+)([A-B])$/);
  if (!match) return 0;
  
  const [, number, letter] = match;
  const baseNumber = parseInt(number);
  return letter === 'B' ? baseNumber + 0.5 : baseNumber;
}

export function isPlantCompatible(
  userZone: Zone,
  plantMinZone: string | null,
  plantMaxZone: string | null
): boolean {
  if (!userZone || !plantMinZone || !plantMaxZone) return false;
  
  const userZoneNum = zoneToNumber(userZone);
  const minZoneNum = zoneToNumber(plantMinZone);
  const maxZoneNum = zoneToNumber(plantMaxZone);
  
  return userZoneNum >= minZoneNum && userZoneNum <= maxZoneNum;
}